// extracted by mini-css-extract-plugin
module.exports = {"recordsSection":"H3adj","closed":"H3adl","headerWrap":"H3kv","time":"H3jz","toggle":"H3adn","list":"H3ar"};